import React from 'react';
import PropTypes from 'prop-types';
import { NavLink, Switch, Route } from 'react-router-dom';

import SubNavItem from './sub-nav-item/SubNavItem';

import './NavItem.scss';

function overrideIsActive(forceIsActive) {
  return function (match, location) {
    if (forceIsActive) {
      return location.search.includes(forceIsActive)
             || (!location.search && match) || window.location.href.includes(forceIsActive);
    } else {
      return match;
    }
  };
}

const NavItem = (props) => {
  const isActiveFunc = overrideIsActive(props.forceIsActive);

  return (
    <span
      className="nav-item-wrapper"
      tabIndex={0}
      role="button"
      onClick={props.triggerSubNav}
      key={props.navItemKey}
    >
      <NavLink
        to={props.route}
        exact={props.exact}
        className={props.navActionClasses}
        activeClassName={props.activeClassName}
        isActive={isActiveFunc}
      >
        {props.icon && <span className={props.iconClasses}>{props.icon}</span>}
        <span className={props.labelClasses}>
          {props.navLabel}
          {props.hasNotification && props.returnNotificationCount}
        </span>
        {props.hasNotification && props.returnCollapsedNotification}
      </NavLink>

      {props.subNav.length > 0 ? (
        
        <div className="subnav" style={{zIndex: 1}}>
          <span className="parentlabel">{props.navLabel}</span>
          {props.subNav.map((subnavitem, index) => (
            <SubNavItem
              key={index}
              route={subnavitem.route}
              navLabel={subnavitem.label}
              icon={subnavitem.icon}
            />
          ))
          }
        </div>

      ) : null}

    </span>
  );
};

NavItem.propTypes = {
  forceIsActive: PropTypes.string,
  triggerSubNav: PropTypes.func,
  route: PropTypes.string,
  exact: PropTypes.bool,
  navActionClasses: PropTypes.string,
  activeClassName: PropTypes.string,
  iconClasses: PropTypes.string,
  labelClasses: PropTypes.string,
  icon: PropTypes.element,
  navLabel: PropTypes.oneOfType([
    PropTypes.string,
    PropTypes.bool,
  ]),
  hasNotification: PropTypes.bool,
  returnNotificationCount: PropTypes.oneOfType([
    PropTypes.object,
    PropTypes.bool,
  ]),
  returnCollapsedNotification: PropTypes.oneOfType([
    PropTypes.object,
    PropTypes.bool,
  ]),
  navItemKey: PropTypes.string,
  subNav: PropTypes.array,
};

NavItem.defaultProps = {
  forceIsActive: '',
  triggerSubNav: () => {},
  route: '#',
  exact: false,
  activeClassName: 'vertical-nav-action vertical-nav-action-active',
  navActionClasses: 'vertical-nav-action',
  iconClasses: 'vertical-nav-icon',
  labelClasses: 'vertical-nav-label',
  icon: null,
  navLabel: false,
  hasNotification: false,
  returnNotificationCount: null,
  returnCollapsedNotification: null,
  navItemKey: '',
  subNav: [],
};

export default NavItem;
